import React, { useId, useState } from "react";
import { CircleHelp } from "lucide-react";

/**
 * Action-queue section title with count and optional progressive-disclosure help.
 */
export default function ActionQueueHeading({ title, count = 0, help = null, helpTestId }) {
  const [open, setOpen] = useState(false);
  const reactId = useId();
  const helpId = `action-queue-help-${reactId}`;
  const showCount = Number(count) > 0;

  return (
    <div>
      <div className="flex items-center gap-1.5 min-h-[28px]">
        <h3 className="font-ui font-semibold text-[16px] text-ink">
          {title}
          {showCount ? (
            <span className="font-medium text-ink/55">{` (${count})`}</span>
          ) : null}
        </h3>
        {help ? (
          <button
            type="button"
            className="inline-flex items-center justify-center w-7 h-7 shrink-0 rounded-btn text-ink/40 hover:text-ink focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-orchid/45"
            aria-expanded={open}
            aria-controls={helpId}
            aria-label={`About ${title}`}
            data-testid={helpTestId}
            onClick={() => setOpen((v) => !v)}
          >
            <CircleHelp className="w-4 h-4" strokeWidth={2.5} aria-hidden />
          </button>
        ) : null}
      </div>
      {open && help ? (
        <p
          id={helpId}
          role="note"
          className="mt-1.5 font-ui text-[13px] text-ink/60 leading-relaxed"
        >
          {help}
        </p>
      ) : null}
    </div>
  );
}
